export const USE_PAGINATION_API = true
export const PAGE_IMAGE = "/images/headers/khub_resource.png"
export const SORT_OPTIONS = ['title', 'date']
export const STATE_KEY = 'organizationResources'
